import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';
import '../styles/armsform.css';

const EditArmsf = () => {
    const { state } = useLocation();
    const navigate = useNavigate();

    const [entry, setEntry] = useState({ ...state.entry });
    const [error, setError] = useState(null);

    useEffect(() => {
        setEntry({ ...state.entry });
    }, [state]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setEntry((prevEntry) => ({
            ...prevEntry,
            [name]: value,
        }));
    };

    const getDashboardUrl = () => {
        if (state?.userRole === 'admin') {
            return '/admin-dashboard';
        } else if (state?.userRole === 'aruid') {
            return '/arms-dashboard';
        } else {
            console.error('Invalid user role:', state?.userRole);
            return '/arms-dashboard';
        }
    };

    const handleCancel = () => {
        navigate(getDashboardUrl());
    };

    const handleSave = async () => {
        try {
            console.log("Sending updated entry:", entry);
    
            const response = await axios.post('https://chaman.gob.pk/eac_backend/arms.php', {
                action: 'update',
                ...entry,
            });
    
            console.log("Backend response:", response.data);
    
            if (response.data?.status === 'success') {
                alert('Entry updated successfully!');
                navigate(getDashboardUrl());
            } else {
                const errorMsg = response.data?.message || 'Failed to update entry';
                setError(errorMsg);
                alert(errorMsg);
            }
        } catch (err) {
            console.error('Update error:', err);
            setError('Error updating entry. Please try again later.');
        }
    };

    return (
        <div className="lc-form-container">
            <form className="lc-form">
                <div className="lc-left-section">
                    <div className="lc-form-group">
                        <label className="lc-label">Token ID:</label>
                        <div className="lc-input-container">
                            <input
                                type="text"
                                name="token_id"
                                value={entry.token_id}
                                onChange={handleChange}
                                className="lc-input"
                                required
                            />
                        </div>
                    </div>
                    <div className="lc-form-group">
                        <label className="lc-label">Name:</label>
                        <div className="lc-input-container">
                            <input
                                type="text"
                                name="name"
                                value={entry.name}
                                onChange={handleChange}
                                className="lc-input"
                                required
                            />
                        </div>
                    </div>
                    <div className="lc-form-group">
                        <label className="lc-label">S/O:</label>
                        <div className="lc-input-container">
                            <input
                                name="father_name"
                                value={entry.father_name}
                                onChange={handleChange}
                                className="lc-input"
                                required
                            />
                        </div>
                    </div>
                    <div className="lc-form-group">
                        <label className="lc-label">Name of Retainer:</label>
                        <div className="lc-input-container">
                            <input
                                type="text"
                                name="gender"
                                value={entry.gender}
                                onChange={handleChange}
                                className="lc-input"
                                required
                            />
                        </div>
                    </div>
                    <div className="lc-form-group">
                        <label className="lc-label">CNIC:</label>
                        <div className="lc-input-container">
                            <input
                                type="text"
                                name="cnic"
                                value={entry.cnic}
                                onChange={handleChange}
                                className="lc-input"
                                required
                            />
                        </div>
                    </div>
                    <div className="lc-form-group">
                        <label className="lc-label">Phone No:</label>
                        <div className="lc-input-container">
                            <input
                                type="text"
                                name="phone_no"
                                value={entry.phone_no}
                                onChange={handleChange}
                                className="lc-input"
                                required
                            />
                        </div>
                    </div>
                    <div className="lc-form-group">
                        <label className="lc-label">R/O:</label>
                        <div className="lc-input-container">
                            <input
                                type="text"
                                name="address"
                                value={entry.address}
                                onChange={handleChange}
                                className="lc-input"
                                required
                            />
                        </div>
                    </div>
                    <div className="lc-form-group">
                        <label className="lc-label">Profession:</label>
                        <div className="lc-input-container">
                            <input
                                type="text"
                                name="profession"
                                value={entry.profession}
                                onChange={handleChange}
                                className="lc-input"
                                required
                            />
                        </div>
                    </div>
                    <div className="lc-form-group">
                        <label className="lc-label">Weapon:</label>
                        <div className="lc-input-container">
                            <input
                                type="text"
                                name="weapon"
                                value={entry.weapon}
                                onChange={handleChange}
                                className="lc-input"
                                required
                            />
                        </div>
                    </div>
                    <div className="lc-form-group">
                        <label className="lc-label">No:</label>
                        <div className="lc-input-container">
                            <input
                                type="text"
                                name="no"
                                value={entry.no}
                                onChange={handleChange}
                                className="lc-input"
                                required
                            />
                        </div>
                    </div>
                </div>

                <div className="lc-right-section">
                    <div className="lc-form-group">
                        <label className="lc-label">Bore:</label>
                        <div className="lc-input-container">
                            <input
                                type="text"
                                name="bore"
                                value={entry.bore}
                                onChange={handleChange}
                                className="lc-input"
                                required
                            />
                        </div>
                    </div>
                    <div className="lc-form-group">
                        <label className="lc-label">Cartridge at a time:</label>
                        <div className="lc-input-container">
                            <input
                                type="text"
                                name="cartridge_s"
                                value={entry.cartridge_s}
                                onChange={handleChange}
                                className="lc-input"
                                required
                            />
                        </div>
                    </div>
                    <div className="lc-form-group">
                        <label className="lc-label">Cartridge Annually:</label>
                        <div className="lc-input-container">
                            <input
                                type="text"
                                name="cartridge_a"
                                value={entry.cartridge_a}
                                onChange={handleChange}
                                className="lc-input"
                                required
                            />
                        </div>
                    </div>
                    <div className="lc-form-group">
                        <label className="lc-label">Validity:</label>
                        <div className="lc-input-container">
                            <input
                                type="text"
                                name="validity"
                                value={entry.validity}
                                onChange={handleChange}
                                className="lc-input"
                                required
                            />
                        </div>
                    </div>
                    <div className="lc-form-group">
                        <label className="lc-label">Expiry:</label>
                        <div className="lc-input-container">
                            <input
                                type="date"
                                name="expiry"
                                value={entry.expiry}
                                onChange={handleChange}
                                className="lc-input"
                                required
                            />
                        </div>
                    </div>
                    <div className="lc-form-group">
                        <label className="lc-label">License No:</label>
                        <div className="lc-input-container">
                            <input
                                type="text"
                                name="license_no"
                                value={entry.license_no}
                                onChange={handleChange}
                                className="lc-input"
                                required
                            />
                        </div>
                    </div>
                    <div className="lc-form-group">
                        <label className="lc-label">Letter No:</label>
                        <div className="lc-input-container">
                            <input
                                type="text"
                                name="local_no"
                                value={entry.local_no}
                                onChange={handleChange}
                                className="lc-input"
                                required
                            />
                        </div>
                    </div>
                    <div className="lc-form-group">
                        <label className="lc-label">Date:</label>
                        <div className="lc-input-container">
                            <input
                                type="date"
                                name="date"
                                value={entry.date}
                                onChange={handleChange}
                                className="lc-input"
                                required
                            />
                        </div>
                    </div>
                    <div className="lc-form-group">
                        <label className="lc-label">Reason:</label>
                        <div className="lc-input-container">
                            <input
                                type="text"
                                name="reason"
                                value={entry.reason}
                                onChange={handleChange}
                                className="lc-input"
                                required
                            />
                        </div>
                    </div>
                    <div className="lc-form-group">
                        <label className="lc-label">Status:</label>
                        <div className="lc-input-container">
                            <select 
                                name="status" 
                                value={entry.status} 
                                onChange={handleChange}
                                className="lc-select"
                                required
                            >
                                <option value="" disabled>Select Status</option>
                                <option value="Recieved">Recieved</option>
                                <option value="Ready">Ready</option>
                            </select>
                        </div>
                    </div>
                </div>
                <div className="lc-form-buttons">
                <button type="button" className="lc-submit-btn" onClick={handleSave}>
                    Update
                </button>
                <button type="button" className="lc-cancel-btn" onClick={handleCancel}>
                    Cancel
                </button>
            </div>
            </form>
           
            {error && <div className="lc-error-message">{error}</div>}
        </div>
    );
};

export default EditArmsf;